<ng-container *ngIf="additionalCobTitles.length; else noAddonsTmpl">
  <lui-avatar
    class="z-2"
    [size]="24"
    [matTooltip]="
      additionalRequestsPrefix + (additionalCobTitles | join : ', ')
    "
    color="orange"
  >
    <mat-icon svgIcon="flag"></mat-icon>
  </lui-avatar>
</ng-container>

<ng-template #noAddonsTmpl>-</ng-template>
